var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-symbol icon-menu-settings theme-undefined",
    "aria-hidden": "true",
    "data-testing-id": "icon-menu-settings",
    "data-element": "svg",
    "data-component": "SvgSymbol",
    "data-source-file": "SvgSymbol.jsx",
    style: {
      width: 24,
      height: 24
    },
    width: 60,
    height: 61,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    fill: "current",
    viewBox: "0 0 60 61",
    id: "icon-menu-settings",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.033 5.628c1.835.022 3.663.234 5.454.633a1.875 1.875 0 0 1 1.455 1.622l.426 3.817a3.46 3.46 0 0 0 3.436 3.082c.474.001.943-.098 1.381-.291l3.502-1.539a1.875 1.875 0 0 1 2.123.435 24.48 24.48 0 0 1 5.512 9.48 1.875 1.875 0 0 1-.679 2.065L49.54 27.22a3.453 3.453 0 0 0 .002 5.566l3.106 2.288c.643.474.915 1.302.679 2.065a24.492 24.492 0 0 1-5.51 9.48 1.875 1.875 0 0 1-2.12.436l-3.517-1.54a3.451 3.451 0 0 0-4.815 2.783l-.423 3.816a1.875 1.875 0 0 1-1.43 1.618 23.796 23.796 0 0 1-11.015 0 1.875 1.875 0 0 1-1.43-1.618l-.421-3.81a3.455 3.455 0 0 0-4.813-2.777l-3.517 1.54a1.874 1.874 0 0 1-2.122-.436 24.495 24.495 0 0 1-5.509-9.49 1.875 1.875 0 0 1 .68-2.064l3.108-2.29a3.452 3.452 0 0 0-.001-5.565l-3.107-2.287a1.875 1.875 0 0 1-.68-2.065 24.481 24.481 0 0 1 5.513-9.48 1.875 1.875 0 0 1 2.123-.435l3.5 1.538a3.44 3.44 0 0 0 3.12-.183 3.467 3.467 0 0 0 1.707-2.613l.425-3.814a1.875 1.875 0 0 1 1.456-1.622 26.66 26.66 0 0 1 5.504-.633Zm0 3.75a22.835 22.835 0 0 0-3.386.293l-.272 2.443a7.214 7.214 0 0 1-3.547 5.437 7.188 7.188 0 0 1-6.514.375l-2.246-.986a20.73 20.73 0 0 0-3.37 5.793l1.995 1.467a7.202 7.202 0 0 1 .002 11.607l-1.997 1.472a20.741 20.741 0 0 0 3.37 5.803l2.262-.99a7.205 7.205 0 0 1 10.042 5.793l.273 2.46c2.224.378 4.496.378 6.72 0l.273-2.46a7.202 7.202 0 0 1 10.046-5.805l2.262.99a20.741 20.741 0 0 0 3.368-5.794l-1.995-1.47a7.203 7.203 0 0 1-.002-11.606l1.992-1.469a20.733 20.733 0 0 0-3.37-5.794l-2.24.985a7.14 7.14 0 0 1-2.9.61 7.21 7.21 0 0 1-7.159-6.419l-.272-2.443a22.47 22.47 0 0 0-3.335-.292Zm-.031 11.25a9.375 9.375 0 1 1 0 18.75 9.375 9.375 0 0 1 0-18.75Zm0 3.75a5.625 5.625 0 1 0 0 11.25 5.625 5.625 0 0 0 0-11.25Z"
  })))), /*#__PURE__*/React.createElement("use", {
    className: "svg-symbol icon-menu-settings theme-undefined",
    xlinkHref: "#icon-menu-settings",
    "data-element": "use",
    "data-source-file": "SvgSymbol.jsx",
    style: {
      width: 24,
      height: 24
    },
    fill: "#FFFFFF"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.335ca64b19b8bf98944977ac33a235e6.svg";
export { ForwardRef as ReactComponent };